import {
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
  } from "@mui/material";
  import { useRef, useState } from "react";
  import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
  import NocsRequests from "../../stores/NocsRequestsStore";
  import General from "../../stores/GeneralStore";
import CloseIcon from "../../assets/CloseIcon.svg";
import { validateDate } from "@mui/x-date-pickers/internals";
import { observer } from "mobx-react";

  interface Obj {
    [key: string]: string;
  }
  
  interface Props {
    onValidateClick: any;
    trackDetails:any;
  }
  
  const TrackStatusModal = ({ trackDetails ,onValidateClick}: Props) => {
    const ColorAss = General?.ColorAss;
    const contrast=General?.contrast;
    return (
      <div
        style={{
          width:General?.isLargeScreen? "30%":"100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          margin: "auto",
          direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",
        }}
      >
         <div
          style={{
            // height: '20%',
            width: "100%",
            justifyContent: "space-between",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            background: "#101e8e",
            display: "flex",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: contrast?.contrastColor ? contrast?.contrastColor :"#fff", justifySelf: "flex-start",fontSize:General?.isLargeScreen?"":"2rem" }}>
          {General?.codeLabels["cm_forms_track"]?.label !== undefined ? General?.codeLabels["cm_forms_track"]?.label : "Track Form"}
          </h1>
          <img src={CloseIcon} alt="" onClick={onValidateClick} />
        </div>
        <div style={{padding:'1rem'}} className="custom-modal-content">
          <div style={{display:'flex',justifyContent:'space-between'}} className="custom-modal-content-row1">
            <div className="custom-modal-content-row1-title">
             {"Reference No"}
            </div>
            <div className="custom-modal-content-row1-value">
              {trackDetails && trackDetails?.id}
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'space-between'}} className="custom-modal-content-row1">
            <div className="custom-modal-content-row1-title">{"Form Type"}</div>
            <div className="custom-modal-content-row1-value">
              {trackDetails && trackDetails?.formType}
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'space-between'}} className="custom-modal-content-row1">
            <div className="custom-modal-content-row1-title">{"Form Status"} </div>
            <div className="custom-modal-content-row1-value">
              {trackDetails && trackDetails?.formStatusCode}
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default observer(TrackStatusModal);
  